import { Injectable } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "src/environments/environment";
import { lastValueFrom } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class EmpresaService extends BaseService {
    
    override recordName = 'empresas';

    override url = `${ environment.host }/empresa`;

    override async getFiltroAdmin(): Promise<Record<string,any>> {
        const cu = this.seguridadService.getCurrentUser();
        if ( !cu.super ) {
            const empresa = cu?.empresa;
            if ( empresa?.autogestion && (empresa.id !== empresa.id_admin ) ) {
                return { field: 'id_admin', value: cu.empresa.id, type: 'id' }
            }
        }
        return {}
    }

    async controlarBloqueo( filtros: Record<string, any>) {      
        let url = `${this.url}/controlar-bloqueo`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  { filtros: filtros } , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async verificarBloqueo( filtros: Record<string, any>) {      
        let url = `${this.url}/verificar-bloqueo`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  { filtros: filtros } , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
}